import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Modal, Form, Button, Popup, Icon } from 'semantic-ui-react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import connect from 'react-redux/es/connect/connect';
import ButtonWrapper from '../../../../common/ButtonWrapper';
import GridColumnInputWrapper from '../../../../common/GridColumnInputWrapper';
import { FieldArray, Formik } from 'formik';
import CommonTagsInputWrapper from '../../../../common/CommonTagsInputWrapper';
import { filterActions } from '../../../../../behavior/filter';
import { chemicalProductsActions } from '../../../../../behavior/chemicalProducts';
import { sdsSearchModalActions } from '../../../../../behavior/sdsSearchModal';
import { FileInputWrapper } from 'react-lib/dist/components-es';

export const CPSdsSearchModalTrigger = ({ onClick, label, tooltip }) => (
  <Popup
    key="sds.search.modal.trigger.tooltip"
    trigger={
      <Button
        key="sds.search.modal.trigger.btn"
        type="button"
        icon="search"
        primary={true}
        onClick={onClick}
        className="mini right floated"
      >
        <Icon name="search" />
        {label}
      </Button>
    }
    on={['hover']}
    size="mini"
    content={tooltip}
    className="ultraWideTooltip"
    position="bottom left"
  />
);

CPSdsSearchModalTrigger.propTypes = { onClick: PropTypes.func.isRequired };

const CPSdsSearchModal = ({
  chemicalProduct,
  t,
  getFileViewerRender,
  getChemicalProductSdsFiles,
  sdsFiles,
  open,
  toggleModal,
}) => {
  let pushToArray;
  useEffect(() => {
    //no other way to have access to formik FieldArray push function
    if (pushToArray && sdsFiles && sdsFiles.length > 0) sdsFiles.forEach(f => pushToArray(f));
  }, [sdsFiles]);

  const getSearchChemicalProducts = push => {
    pushToArray = push; //no other way to have access to formik FieldArray push function
    return (
      <Formik
        initialValues={[]}
        enableReinitialize
        onSubmit={values => {
          getChemicalProductSdsFiles(
            values.selectedProducts[values.selectedProducts.length - 1].id
          );
        }}
        render={({ setFieldValue, handleSubmit, values }) => (
          <>
            <Grid.Column tablet={8} mobile={8} computer={10}>
              <CommonTagsInputWrapper
                setFieldValue={setFieldValue}
                name="selectedProducts"
                dynamicSuggestionListActionWithName={filterActions.getAutoCompleteSuggestionsList.bind(
                  this,
                  true
                )}
                dynamicSuggestionName="EXCLUDED_GEN_TRADE_CHEMICAL_NAMES"
                matchProperty="id"
                displayProps="tradeName,chemicalName"
                onlyUnique={true}
                placeholder="sds.search.modal.products.tags.input.placeholder"
                onSelect={v => {
                  setTimeout(() => {
                    if (v.length > (values.selectedProducts || []).length) handleSubmit(); //only if addition
                  }, 0);
                }}
              />
            </Grid.Column>
          </>
        )}
      />
    );
  };

  const getSdsFilesComponent = formikProps => {
    return (
      <FieldArray
        name="newSdsFiles"
        render={({ push }) => (
          <Grid>
            <Grid.Row>
              <GridColumnInputWrapper
                name="newSdsFiles"
                fileDataProp="fileData"
                value={formikProps.values.newSdsFiles}
                displayOnlyFirstLevelErrors={true}
                fieldClassName="sdsFiles"
                render={props => (
                  <FileInputWrapper
                    {...props}
                    {...formikProps}
                    errors={{}}
                    multiple={true}
                    errorPaths={[]}
                    hideFile={f => f[props.fileDataProp].deleted || f[props.fileDataProp].delUser}
                    displayInput={false}
                    fileViewerRender={props => getFileViewerRender(props)}
                  />
                )}
              />
            </Grid.Row>
            <Grid.Row>{getSearchChemicalProducts(push)}</Grid.Row>
          </Grid>
        )}
      />
    );
  };

  return (
    <Modal
      trigger={
        <CPSdsSearchModalTrigger
          onClick={() => toggleModal(true)}
          label={t('sds.search.modal.trigger.label')}
          tooltip={t('sds.search.modal.trigger.tooltip')}
        />
      }
      centered={true}
      open={open}
      onClose={() => toggleModal(false)}
      size="small"
    >
      <Modal.Header>{t('sds.search.modal.title')}</Modal.Header>
      <Modal.Content>
        <Formik
          initialValues={{ newSdsFiles: [] }}
          render={formikProps => (
            <Form>
              <Grid
                verticalAlign="top"
                columns={1}
                className="containerReducedWhiteSpace sdsSearchModal"
              >
                <Grid.Column>{getSdsFilesComponent(formikProps)}</Grid.Column>
                <Grid.Column tablet={8} mobile={8} computer={10} />
                <Grid.Column tablet={8} mobile={8} computer={6}>
                  <Button.Group className="mini right floated">
                    <ButtonWrapper
                      type="button"
                      label={t(`cancel.button`)}
                      onClick={() => toggleModal(false)}
                      color="red"
                    />
                    <ButtonWrapper
                      key="sds.search.modal.submit.btn"
                      type="button"
                      label={t('sds.search.modal.copy.button')}
                      onClick={() => {
                        chemicalProduct.sdsFiles.push(...formikProps.values.newSdsFiles);
                        toggleModal(false);
                      }}
                      primary={true}
                    />
                  </Button.Group>
                </Grid.Column>
              </Grid>
            </Form>
          )}
        />
      </Modal.Content>
    </Modal>
  );
  // }
};

CPSdsSearchModal.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  sdsFiles: state.chemicalProducts.sdsFiles,
  ...state.sdsSearchModal,
});

const mapDispatchToProps = dispatch => ({
  getChemicalProductSdsFiles: id =>
    dispatch(chemicalProductsActions.getChemicalProductSdsFiles(id, true)),
  toggleModal: state => dispatch(sdsSearchModalActions.toggle(state)),
});

CPSdsSearchModal.defaultProps = {
  externalTrigger: false,
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(CPSdsSearchModal);
